import React, {PropsWithChildren} from "react"
import {Box, Fade, Typography} from "@mui/material"
import {PropsWithTheme} from "../../library/Theme"

interface IconButtonProps {
  text?: string | null
  onPress: () => void
}

export default function IconButton({
                                     theme,
                                     text,
                                     onPress,
                                     children,
                                   }: PropsWithChildren<PropsWithTheme<IconButtonProps>>) {
  return (
    <Fade in appear timeout={300}>
      <Box
        sx={{
          display: "inline-block",
          transition: "transform 0.2s",
          "&:hover": {
            transform: "scale(1.1)",
          },
        }}
      >
        <Box
          onClick={onPress}
          sx={{
            display: "inline-block",
            outline: "10px solid transparent",
            p: "23px",
            mx: "15px",
            borderRadius: "50%",
            cursor: "pointer",
            overflow: "visible",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.14)",
            transition: "transform 0.2s",
            "&:active": {
              transform: "translateY(5px)",
            },
            "& svg": {
              width: 38,
              height: 38,
            },
            ...theme.buttonStyle,
          }}
        >
          {children}
        </Box>
        {text && (
          <>
            <br/>
            <Typography
              component="span"
              sx={{
                display: "inline-block",
                mt: "6px",
                fontSize: "10px",
                fontWeight: 600,
                letterSpacing: 0,
                lineHeight: "14px",
                maxWidth: 100,
                ...theme.textStyle,
              }}
            >
              {text}
            </Typography>
          </>
        )}
      </Box>
    </Fade>
  )
}
